import React, { useEffect, useState } from 'react';
import { Container, Typography } from '@mui/material';
import TokenForm from './components/TokenForm';
import UpdatePanel from './components/UpdatePanel';

export default function App() {
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    fetch('/api/auth').then(r => r.json()).then((d: { authed: boolean }) => setAuthed(d.authed));
  }, []);

  if (authed === null) return null;

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>База знаний</Typography>
      {authed
        ? <UpdatePanel onLogout={() => setAuthed(false)} />
        : <TokenForm onSuccess={() => setAuthed(true)} />}
    </Container>
  );
}
